import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./HRModelerAnalytics.styles";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import HRModelerAnalyticsFiltersAndReports from "./HRModelerAnalyticsFiltersAndReports.component";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import { ApprovalProvider } from "../../../context/ApprovalContext";
import { EmailProvider } from "../../../context/EmailContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const HRModelerAnalytics = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <ApprovalProvider>
              <EmailProvider>
                <HRModelerAnalyticsFiltersAndReports
                  toSave={true}
                  toCompare={toCompare}
                  toDisableEntitySelection={false}
                  reportLocated={"LEFT"}
                />
              </EmailProvider>
            </ApprovalProvider>
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>
        {toCompare && (
          <HedgeRatioProvider>
            <TreasuryKRISummaryProvider>
              <ApprovalProvider>
                <EmailProvider>
                  <HRModelerAnalyticsFiltersAndReports
                    toSave={false}
                    toCompare={toCompare}
                    toDisableEntitySelection={true}
                    reportLocated={"RIGHT"}
                  />
                </EmailProvider>
              </ApprovalProvider>
            </TreasuryKRISummaryProvider>
          </HedgeRatioProvider>
        )}
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default HRModelerAnalytics;
